import React from 'react';
import { ArticleSeries } from '../../../../../types/articleType';
import ArticleSeriesItem from '../ArticleSeriesItem/ArticleSeriesItem';
import * as S from './Styles';

type Props = {
  articleSeries: ArticleSeries;
};

const ArticleSeriesFooter = ({ articleSeries }: Props) => {
  const { items } = articleSeries;
  const currentIndex = items.findIndex((item) => item.isActive);
  const orderedItems = currentIndex === -1 ? items : [...items.slice(currentIndex), ...items.slice(0, currentIndex)];

  return (
    <S.Wrapper>
      {orderedItems.map((article) => (
        <ArticleSeriesItem key={article.id} article={article} size="large" showBorder layout="vertical" />
      ))}
    </S.Wrapper>
  );
};

export default ArticleSeriesFooter;
